module.exports = __webpack_public_path__ + "img/illu.fd454894.png";